import { ModalDialog } from 'components/ModalDialog';

import type React from 'react';
import { useRef } from 'react';

import Style from './DockableModal.module.css';

export const DockableModal: React.FC = () => {
    const dialogBottomRef = useRef(null);
    const dialogTopRef = useRef(null);

    return (
        <div className={Style.dockableModal}>
            <div className="columned">
                <div ref={dialogTopRef}>
                    <ModalDialog
                        title="Диалог Верх"
                        onClose={() => false}
                        hasOverlay={false}
                        isOpen
                        isDockedToContainer
                        containerRef={dialogTopRef}
                    >
                        Диалог Верх
                    </ModalDialog>
                </div>
                <div ref={dialogBottomRef}>
                    <ModalDialog
                        title="Диалог Низ"
                        hasOverlay={false}
                        isOpen
                        onClose={() => false}
                        isDockedToContainer
                        containerRef={dialogBottomRef}
                    >
                        Диалог Низ
                    </ModalDialog>
                </div>
            </div>
            <ModalDialog title="Диалог к низу страницы" onClose={() => false} hasOverlay isOpen dockedToWindow="bottom">
                Диалог Низ страницы
            </ModalDialog>
        </div>
    );
};

DockableModal.displayName = 'DockableModal';
